"use strict";

var _toConsumableArray = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var conversions = require("webidl-conversions");

var utils = require("./utils.js");

var implSymbol = utils.implSymbol;
var ctorRegistrySymbol = utils.ctorRegistrySymbol;
var interfaceName = "Plugin";

exports.is = function (value) {
  return utils.isObject(value) && utils.hasOwn(value, implSymbol) && value[implSymbol] instanceof Impl.implementation;
};

exports.isImpl = function (value) {
  return utils.isObject(value) && value instanceof Impl.implementation;
};

exports.convert = function (value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? "The provided value" : _ref$context;

  if (exports.is(value)) {
    return utils.implForWrapper(value);
  }

  throw new TypeError("".concat(context, " is not of type 'Plugin'."));
};

function makeWrapper(globalObject) {
  if (globalObject[ctorRegistrySymbol] === undefined) {
    throw new Error("Internal error: invalid global object");
  }

  var ctor = globalObject[ctorRegistrySymbol]["Plugin"];

  if (ctor === undefined) {
    throw new Error("Internal error: constructor Plugin is not installed on the passed global object");
  }

  return Object.create(ctor.prototype);
}

exports.create = function (globalObject, constructorArgs, privateData) {
  var wrapper = makeWrapper(globalObject);
  return exports.setup(wrapper, globalObject, constructorArgs, privateData);
};

exports.createImpl = function (globalObject, constructorArgs, privateData) {
  var wrapper = exports.create(globalObject, constructorArgs, privateData);
  return utils.implForWrapper(wrapper);
};

exports._internalSetup = function (wrapper, globalObject) {};

exports.setup = function (wrapper, globalObject) {
  var constructorArgs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var privateData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  privateData.wrapper = wrapper;

  exports._internalSetup(wrapper, globalObject);

  Object.defineProperty(wrapper, implSymbol, {
    value: new Impl.implementation(globalObject, constructorArgs, privateData),
    configurable: true
  });
  wrapper = new Proxy(wrapper, proxyHandler);
  wrapper[implSymbol][utils.wrapperSymbol] = wrapper;

  if (Impl.init) {
    Impl.init(wrapper[implSymbol]);
  }

  return wrapper;
};

exports.new = function (globalObject) {
  var wrapper = makeWrapper(globalObject);

  exports._internalSetup(wrapper, globalObject);

  Object.defineProperty(wrapper, implSymbol, {
    value: Object.create(Impl.implementation.prototype),
    configurable: true
  });
  wrapper = new Proxy(wrapper, proxyHandler);
  wrapper[implSymbol][utils.wrapperSymbol] = wrapper;

  if (Impl.init) {
    Impl.init(wrapper[implSymbol]);
  }

  return wrapper[implSymbol];
};

var exposed = new Set(["Window"]);

exports.install = function (globalObject, globalNames) {
  var _Object$definePropert;

  if (!globalNames.some(function (globalName) {
    return exposed.has(globalName);
  })) {
    return;
  }

  var Plugin =
  /*#__PURE__*/
  function () {
    function Plugin() {
      _classCallCheck(this, Plugin);

      throw new TypeError("Illegal constructor");
    }

    _createClass(Plugin, [{
      key: "item",
      value: function item(index) {
        var _esValue$implSymbol;

        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'item' called on an object that is not a valid instance of Plugin.");
        }

        if (arguments.length < 1) {
          throw new TypeError("Failed to execute 'item' on 'Plugin': 1 argument required, but only " + arguments.length + " present.");
        }

        var args = [];
        {
          var curArg = arguments[0];
          curArg = conversions["unsigned long"](curArg, {
            context: "Failed to execute 'item' on 'Plugin': parameter 1"
          });
          args.push(curArg);
        }
        return utils.tryWrapperForImpl((_esValue$implSymbol = esValue[implSymbol]).item.apply(_esValue$implSymbol, args));
      }
    }, {
      key: "namedItem",
      value: function namedItem(name) {
        var _esValue$implSymbol2;

        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'namedItem' called on an object that is not a valid instance of Plugin.");
        }

        if (arguments.length < 1) {
          throw new TypeError("Failed to execute 'namedItem' on 'Plugin': 1 argument required, but only " + arguments.length + " present.");
        }

        var args = [];
        {
          var curArg = arguments[0];
          curArg = conversions["DOMString"](curArg, {
            context: "Failed to execute 'namedItem' on 'Plugin': parameter 1"
          });
          args.push(curArg);
        }
        return utils.tryWrapperForImpl((_esValue$implSymbol2 = esValue[implSymbol]).namedItem.apply(_esValue$implSymbol2, args));
      }
    }, {
      key: "name",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get name' called on an object that is not a valid instance of Plugin.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["name"]);
      }
    }, {
      key: "description",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get description' called on an object that is not a valid instance of Plugin.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["description"]);
      }
    }, {
      key: "filename",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get filename' called on an object that is not a valid instance of Plugin.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["filename"]);
      }
    }, {
      key: "length",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get length' called on an object that is not a valid instance of Plugin.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["length"]);
      }
    }]);

    return Plugin;
  }();

  Object.defineProperties(Plugin.prototype, (_Object$definePropert = {
    item: {
      enumerable: true
    },
    namedItem: {
      enumerable: true
    },
    name: {
      enumerable: true
    },
    description: {
      enumerable: true
    },
    filename: {
      enumerable: true
    },
    length: {
      enumerable: true
    }
  }, _defineProperty(_Object$definePropert, Symbol.toStringTag, {
    value: "Plugin",
    configurable: true
  }), _defineProperty(_Object$definePropert, Symbol.iterator, {
    value: Array.prototype[Symbol.iterator],
    configurable: true,
    writable: true
  }), _Object$definePropert));

  if (globalObject[ctorRegistrySymbol] === undefined) {
    globalObject[ctorRegistrySymbol] = Object.create(null);
  }

  globalObject[ctorRegistrySymbol][interfaceName] = Plugin;
  Object.defineProperty(globalObject, interfaceName, {
    configurable: true,
    writable: true,
    value: Plugin
  });
};

var proxyHandler = {
  get: function get(target, P, receiver) {
    if (typeof P === "symbol") {
      return Reflect.get(target, P, receiver);
    }

    var desc = this.getOwnPropertyDescriptor(target, P);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(target);

      if (parent === null) {
        return undefined;
      }

      return Reflect.get(target, P, receiver);
    }

    if (!desc.get && !desc.set) {
      return desc.value;
    }

    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return Reflect.apply(getter, receiver, []);
  },
  has: function has(target, P) {
    if (typeof P === "symbol") {
      return Reflect.has(target, P);
    }

    var desc = this.getOwnPropertyDescriptor(target, P);

    if (desc !== undefined) {
      return true;
    }

    var parent = Object.getPrototypeOf(target);

    if (parent !== null) {
      return Reflect.has(parent, P);
    }

    return false;
  },
  ownKeys: function ownKeys(target) {
    var keys = new Set();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = target[implSymbol][utils.supportedPropertyIndices][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;
        keys.add("".concat(key));
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = Reflect.ownKeys(target)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _key = _step2.value;
        keys.add(_key);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return _toConsumableArray(keys);
  },
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, P) {
    if (typeof P === "symbol") {
      return Reflect.getOwnPropertyDescriptor(target, P);
    }

    var ignoreNamedProps = false;

    if (utils.isArrayIndexPropName(P)) {
      var index = P >>> 0;

      if (target[implSymbol][utils.supportsPropertyIndex](index)) {
        var indexedValue = target[implSymbol].item(index);
        return {
          writable: false,
          enumerable: true,
          configurable: true,
          value: utils.tryWrapperForImpl(indexedValue)
        };
      }

      ignoreNamedProps = true;
    }

    return Reflect.getOwnPropertyDescriptor(target, P);
  },
  set: function set(target, P, V, receiver) {
    if (typeof P === "symbol") {
      return Reflect.set(target, P, V, receiver);
    } // The `receiver` argument refers to the Proxy exotic object or an object
    // that inherits from it, whereas `target` refers to the Proxy target:


    if (target[implSymbol][utils.wrapperSymbol] === receiver) {}

    var ownDesc;

    if (utils.isArrayIndexPropName(P)) {
      var index = P >>> 0;

      if (target[implSymbol][utils.supportsPropertyIndex](index)) {
        var indexedValue = target[implSymbol].item(index);
        ownDesc = {
          writable: false,
          enumerable: true,
          configurable: true,
          value: utils.tryWrapperForImpl(indexedValue)
        };
      }
    }

    if (ownDesc === undefined) {
      ownDesc = Reflect.getOwnPropertyDescriptor(target, P);
    }

    if (ownDesc === undefined) {
      var parent = Reflect.getPrototypeOf(target);

      if (parent !== null) {
        return Reflect.set(parent, P, V, receiver);
      }

      ownDesc = {
        writable: true,
        enumerable: true,
        configurable: true,
        value: undefined
      };
    }

    if (!ownDesc.writable) {
      return false;
    }

    if (!utils.isObject(receiver)) {
      return false;
    }

    var existingDesc = Reflect.getOwnPropertyDescriptor(receiver, P);
    var valueDesc;

    if (existingDesc !== undefined) {
      if (existingDesc.get || existingDesc.set) {
        return false;
      }

      if (!existingDesc.writable) {
        return false;
      }

      valueDesc = {
        value: V
      };
    } else {
      valueDesc = {
        writable: true,
        enumerable: true,
        configurable: true,
        value: V
      };
    }

    return Reflect.defineProperty(receiver, P, valueDesc);
  },
  defineProperty: function defineProperty(target, P, desc) {
    if (typeof P === "symbol") {
      return Reflect.defineProperty(target, P, desc);
    }

    if (utils.isArrayIndexPropName(P)) {
      return false;
    }

    return Reflect.defineProperty(target, P, desc);
  },
  deleteProperty: function deleteProperty(target, P) {
    if (typeof P === "symbol") {
      return Reflect.deleteProperty(target, P);
    }

    if (utils.isArrayIndexPropName(P)) {
      var index = P >>> 0;
      return !target[implSymbol][utils.supportsPropertyIndex](index);
    }

    return Reflect.deleteProperty(target, P);
  },
  preventExtensions: function preventExtensions() {
    return false;
  }
};

var Impl = require("../navigator/Plugin-impl.js");